import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="bg-[#0a0a0a] py-24 px-4 border-t-4 border-[#a855f7]" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-148">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-149">
            🚨 La inteligencia artificial está reemplazando horas de trabajo…
          </h2>
          <p className="text-2xl md:text-3xl text-red-500 font-bold" data-id="element-150">
            pero casi nadie sabe usarla bien.
          </p>
        </motion.div>

        <div className="bg-[#111] border border-white/10 rounded-2xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-151">
          <p className="text-xl text-white mb-6 font-semibold" data-id="element-152">
            Hoy existen herramientas capaces de:
          </p>
          <ul className="space-y-4 mb-8 text-lg text-[#c4b5d4]" data-id="element-153">
            {['crear imágenes profesionales', 'generar voces realistas', 'producir videos automáticamente', 'escribir contenido', 'automatizar tareas'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-154">
                <CheckIcon className="text-green-500 w-6 h-6 flex-shrink-0" data-id="element-155" />
                <span data-id="element-156">{item}</span>
              </li>)}
          </ul>
          <p className="text-2xl text-[#FFD700] font-bold mb-4" data-id="element-157">
            Todo en minutos.
          </p>
          <p className="text-xl text-white" data-id="element-158">
            Pero la mayoría de las personas no sabe por dónde empezar.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="mb-16" data-id="element-159">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center" data-id="element-160">
            ⚠️ El problema
          </h3>
          <p className="text-xl text-center text-[#c4b5d4] mb-8" data-id="element-161">
            Todos escuchan hablar de:
            <br data-id="element-162" />
            <span className="text-white font-semibold mt-2 block" data-id="element-163">
              Gemini • Midjourney • generadores de video • IA para voz •
              avatares con inteligencia artificial
            </span>
          </p>

          <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-8 md:p-12" data-id="element-164">
            <p className="text-xl text-white mb-6 font-semibold text-center" data-id="element-165">
              Pero cuando intentan usarlas…
            </p>
            <ul className="space-y-4 text-lg text-[#c4b5d4] max-w-2xl mx-auto" data-id="element-166">
              {['no saben qué herramientas usar', 'pierden horas viendo tutoriales', 'se sienten abrumados', 'terminan abandonando'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-167">
                  <XIcon className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-168" />
                  <span data-id="element-169">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <div className="text-center bg-gradient-to-r from-[#1a0533] to-[#2d1052] p-8 rounded-2xl border border-[#a855f7]/30 mb-16" data-id="element-170">
          <p className="text-xl text-[#c4b5d4] mb-4" data-id="element-171">Mientras tanto…</p>
          <p className="text-2xl md:text-3xl text-white font-bold leading-relaxed" data-id="element-172">
            Hay personas que ya están utilizando inteligencia artificial para
            crear contenido, trabajar más rápido y generar nuevas oportunidades.
          </p>
        </div>

        <div className="text-center" data-id="element-173">
          <CTAButton data-id="element-174">🔥 ¡QUIERO EMPEZAR HOY!</CTAButton>
        </div>
      </div>
    </section>;
}